import { c as _c } from "react/compiler-runtime";
import Link from '@/components/ui/Link';
import { BreadcrumbItem } from '@/lib/types/articleTemplate';
import { resolveBreadcrumbItems } from '@/lib/articleTemplateFields';
export interface BreadcrumbTrailProps {
  items: BreadcrumbItem[] | undefined;
  story: Record<string, unknown> | null | undefined;
}

/**
 * Renders Level1 / Level2 / ... / LastLevel (last level styled active).
 * Shared by ArticleHeroSection's `breadcrumb` field and the standalone
 * ArticleBreadcrumb component type.
 */
export default function BreadcrumbTrail(t0) {
  const $ = _c(10);
  const {
    items,
    story
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== items || $[1] !== story) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolved = resolveBreadcrumbItems(items, story);
      if (resolved.length === 0) {
        t4 = null;
        break bb0;
      }
      t1 = "Breadcrumb";
      t2 = "flex flex-wrap items-center gap-1 text-14-tamil-500 text-4D4D4D p-3 border-b border-DCDCDC";
      t3 = resolved.map((item, idx) => {
        const isLast = idx === resolved.length - 1;
        return <span key={item.id} className="flex items-center gap-1">{idx > 0 && <span aria-hidden="true">/</span>}{isLast ? <span className="text-1B1B1B text-14-tamil-700">{item.label}</span> : <Link href={item.url || "#"} className="hover:text-012061">{item.label}</Link>}</span>;
      });
    }
    $[0] = items;
    $[1] = story;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t5 = <nav aria-label={t1} className={t2}>{t3}</nav>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}